import { differenceInHours, differenceInMinutes, format } from 'date-fns'
import { TypeOrNull } from '@network/models/common.model'
import { SHIFT_TYPE } from '@network/models/shift.model'
import { calculateEndDateFomStartDateAndHours } from 'helpers/shiftHelpers'
import { TShiftLengthCheckerError } from 'helpers/shiftHelpers/types'
import { IModalDuplicateShiftValues } from 'helpers/shiftHelpers/types'
import { DATE_FORMAT_STRING } from 'helpers/timeAndDateHelpers/constants'

export const isShiftShort = (
  shiftValues: any[] | IModalDuplicateShiftValues,
) => {
  if (Array.isArray(shiftValues) && shiftValues.length) {
    return shiftValues.filter(
      shift =>
        calculateShiftDurationHours(
          format(new Date(shift.date_start), DATE_FORMAT_STRING.MM_dd_yyyy),
          shift.hour_start,
          shift.hour_end,
        ) < 5 && shift.break > 0,
    ).length
  }
  return 0
}

export const calculateShiftDurationHours = (
  dateStart: string,
  hourStart: string,
  hourEnd: string,
) => {
  const endDate = calculateEndDateFomStartDateAndHours(
    dateStart,
    hourStart,
    hourEnd,
  )

  const endDateTime = new Date(`${endDate}  ${hourEnd}`)
  const startDateTime = new Date(`${dateStart}  ${hourStart}`)
  const shiftHoursLength = differenceInHours(endDateTime, startDateTime)

  return shiftHoursLength
}

export const calculateShiftDurationMinutes = (
  dateStart: string,
  hourStart: string,
  hourEnd: string,
) => {
  const endDate = calculateEndDateFomStartDateAndHours(
    dateStart,
    hourStart,
    hourEnd,
  )

  const endDateTime = new Date(`${endDate}  ${hourEnd}`)
  const startDateTime = new Date(`${dateStart}  ${hourStart}`)
  const shiftMinutesLength = differenceInMinutes(endDateTime, startDateTime)

  return shiftMinutesLength
}

/**
 * Function that checks if the Shift's length is valid
 * @param shift Array of single day shifts or a single multiday shift pbject
 */
export const shiftLengthChecker = (
  shift: any,
): TypeOrNull<TShiftLengthCheckerError> => {
  let shiftLengthError: TypeOrNull<TShiftLengthCheckerError> = null

  // When the shift is Single Day, the shift param will be an array (it can be of multiple shift objects, but they all have the same start and end time)
  if (Array.isArray(shift)) {
    if (Number(shift[0].type) === SHIFT_TYPE.SINGLEDAY) {
      for (let i = 0; i < shift.length; i++) {
        const { date_start, hour_start, hour_end } = shift[i]
        const shiftHoursLength = calculateShiftDurationHours(
          date_start.toString(),
          hour_start,
          hour_end,
        )

        const shiftMinutesLength = calculateShiftDurationMinutes(
          date_start,
          hour_start,
          hour_end,
        )

        if (shiftHoursLength > 15) {
          shiftLengthError = {
            message: 'Cannot post shift over 15 hours',
            day_id: shift[i].date_start,
          }
          break
        }

        if (shiftHoursLength === 0 && shiftMinutesLength < 30) {
          if (shiftMinutesLength === 0) {
            shiftLengthError = {
              message: 'Cannot post shift with the same Start and End Time',
              day_id: shift[i].date_start,
            }
            break
          } else {
            shiftLengthError = {
              message: "Cannot post a shift that's less than half an hour long",
              day_id: shift[i].date_start,
            }
            break
          }
        }
      }
    }
  } else if (Number(shift.type) === SHIFT_TYPE.MULTIDAY) {
    const shiftDays = shift.days

    for (let i = 0; i < shiftDays.length; i++) {
      const { date_start, hour_start, hour_end, id } = shiftDays[i]
      const dayHoursLength = calculateShiftDurationHours(
        date_start,
        hour_start,
        hour_end,
      )

      const dayMinutesLength = calculateShiftDurationMinutes(
        date_start,
        hour_start,
        hour_end,
      )

      if (dayHoursLength > 15) {
        shiftLengthError = {
          message: 'Cannot post shift over 15 hours',
          day_id: id,
        }
        break
      }

      if (dayHoursLength === 0 && dayMinutesLength < 30) {
        if (dayMinutesLength === 0) {
          shiftLengthError = {
            message: 'Cannot post shift with the same Start and End Time',
            day_id: id,
          }
          break
        } else {
          shiftLengthError = {
            message: "Cannot post a shift that's less than half an hour long",
            day_id: id,
          }
          break
        }
      }
    }
  }

  return shiftLengthError
}
